export const PageNotFound = () => {
  return (
    <div className="flex h-[80vh] items-center justify-center text-3xl font-bold">
      <h2>Page not found</h2>
    </div>
  );
};
